var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22839 13.1074C11.4146 13.1074 14.7987 8.20089 14.7987 3.95341C14.7987 3.81611 14.7987 3.67685 14.7926 3.53955C15.4514 3.08301 16.0201 2.51779 16.4718 1.87037C15.8564 2.13011 15.2042 2.3013 14.5365 2.37838C15.2398 1.97593 15.7667 1.34271 16.019 0.596416C15.3581 0.971171 14.6348 1.23425 13.8807 1.37412C13.3738 0.85731 12.7029 0.514936 11.9721 0.400035C11.2413 0.285134 10.4912 0.404118 9.8382 0.738558C9.18517 1.073 8.66556 1.60423 8.35988 2.24996C8.0542 2.8957 7.9795 3.6199 8.14734 4.31039C6.81003 4.2462 5.50175 3.91366 4.30736 3.33433C3.11296 2.75499 2.05912 1.94181 1.21418 0.947513C0.785245 1.65665 0.654342 2.49548 0.848057 3.29365C1.04177 4.09182 1.54558 4.7895 2.25718 5.24501C1.72394 5.22767 1.20242 5.09061 0.734694 4.84488V4.88901C0.735613 5.63189 1.00447 6.35168 1.49581 6.92671C1.98715 7.50174 2.67084 7.89675 3.43132 8.04496C3.14266 8.12108 2.84448 8.15902 2.54508 8.15774C2.33401 8.15836 2.12335 8.13964 1.916 8.10184C2.13094 8.74133 2.54946 9.30044 3.11294 9.70088C3.67641 10.1013 4.35663 10.323 5.05831 10.3349C3.8663 11.2311 2.39386 11.7172 0.878131 11.7148C0.611051 11.7159 0.344158 11.7011 0.0789795 11.6707C1.61736 12.6095 3.40396 13.108 5.22839 13.1074Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.40ba15a6a041e1b39c407fb2692aece8.svg";
export { ForwardRef as ReactComponent };